import { render } from "./notificationlist.vue?vue&type=template&id=81c3db5e&scoped=true"
import script from "./notificationlist.vue?vue&type=script&lang=js"
export * from "./notificationlist.vue?vue&type=script&lang=js"

import "./notificationlist.vue?vue&type=style&index=0&id=81c3db5e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c3db5e"]])

export default __exports__